import {  createAsyncThunk, createSlice, SerializedError } from '@reduxjs/toolkit'
import { Auth } from 'aws-amplify';
import { RootState } from '../../../store/store';
import { Loading, sessionUpdated } from '../../../App/app';
import { feedback } from '../../../components/Feedback/feedback';
import { authenticateUser } from '../../../store/api/authenticate-user';
import i18n from '../../../i18n/i18n';
import { hgsKeyBackendUri } from '../../../uris';
import apiMessage from "../../../i18n/api/api-messages";


export interface State {
  // email: string,
  // emailVerified: boolean,
  // modified: boolean,
  loading: Loading,
  currentRequestId: string,
  error: SerializedError | null,
}

const initialState: State = {
  // email: '',
  // emailVerified: false,
  // modified: false,
  loading: 'idle',
  currentRequestId: '',
  error: null,
}

interface EmailPayload {
  email?: string,
  emailVerified?: boolean,
  modified?: boolean,
}

export const updateEmailAttribute = createAsyncThunk(
  'updateYourEmail/updateEmailAttribute',
  async ( email: string, thunkAPI ) => {
    const settingsT = i18n.getFixedT( null, 'settings');
    // TODO: move state AFTER sessionUpdated has been dispatched
    const state = thunkAPI.getState() as RootState;
    const { currentRequestId, loading } = state.pages.settings.updateYourEmail;

    if (loading !== 'pending' || thunkAPI.requestId !== currentRequestId) return

    const redirectURI = state.app.searchParameters.redirect_uri ? new URL(state.app.searchParameters.redirect_uri).origin : '';

    return Auth.currentAuthenticatedUser().then( cognitoUser => {
      thunkAPI.dispatch(sessionUpdated({
        accessToken: cognitoUser.signInUserSession.accessToken.jwtToken,
        refreshToken: cognitoUser.signInUserSession.refreshToken.token,
        idToken: cognitoUser.signInUserSession.idToken.jwtToken
      }));

      return fetch(`${hgsKeyBackendUri}/checkIfEmailInUse?context=settings`, {
        method: 'POST',
        headers: {
          "Authorization": state.app.session.idToken,
          "Content-Type": "text/plain",
        },
        body: JSON.stringify({
          inputEmail: email
        }),
        redirect: 'follow'
      }).then(response => {
        if (!response.ok) {
            response.text().then(text => {
              const apiT = i18n.getFixedT(null, 'api');
              thunkAPI.dispatch(feedback({ message: apiT( apiMessage(<any>text)), severity: 'error' }));
            });
            return false;
          }
          else {
            const clientMetaDataWithEmail = {
                clientMetaEmail: email,
                redirectURI: redirectURI,
                username: state.app.attributes['custom:user_profile_uuid'] || '',
                language: state.app.language
              }
              return Auth.updateUserAttributes( cognitoUser, { email }, clientMetaDataWithEmail )
              .then( () => {

                // bypassCache necessary to update real unverified email state.

                return thunkAPI.dispatch( authenticateUser()).then( () => {
                  thunkAPI.dispatch( feedback( { message: settingsT('email-has-been-sent'), severity: 'success' } ))
                  return true;
                })
            });
          }
      })
    }).catch( error => {
      const message = typeof error === 'string' ? error : error.message;
      const apiT = i18n.getFixedT(null, 'api');
      thunkAPI.dispatch( feedback( { message: apiT(apiMessage(message)), severity: 'error' } ))
      return false;
    })
  }
)

export const updateYourEmailSlice = createSlice({
  name: 'updateYourEmail',
  initialState,
  reducers: {
  },
  extraReducers: ( builder ) => {
    builder.addCase( updateEmailAttribute.pending, (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    })
    .addCase( updateEmailAttribute.fulfilled, (state, action) => {
      const { requestId } = action.meta
      if ( state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.currentRequestId = '';
      }
    })
    .addCase( updateEmailAttribute.rejected, ( state, action, ) => {

      const { requestId } = action.meta

      if ( state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = '';
      }
    })
  }
})

export const { } = updateYourEmailSlice.actions

export default updateYourEmailSlice.reducer
